import baseApi from '../utils/ApiUtils';

export const paymentAction= (method, id, payload = null, params = null) => {
  return baseApi(`/payments/${id}/transition/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const payServices= (method, payload = null, params = null) => {
  return baseApi(`/pay/`, method, params, payload).then(response => {
    return response.data;
  });
};